import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import type { SvgIconProps } from '@mui/material';

/** Icon for a CSP source by its `jurisdiction_type` (state / organization / school). */
export function SourceIcon({
  type,
  ...props
}: { type?: string | null } & Omit<SvgIconProps, 'type'>) {
  switch (type) {
    case 'state':
      return <AccountBalanceOutlinedIcon {...props} />;
    case 'organization':
      return <BusinessOutlinedIcon {...props} />;
    case 'school':
      return <SchoolOutlinedIcon {...props} />;
    default:
      return <PublicOutlinedIcon {...props} />;
  }
}

export default SourceIcon;
